interface NavLink {
  href?: string
  title: string
  submenu?: { href: string; title: string; openInNewTab?: boolean }[]
  openInNewTab?: boolean
  isButton?: boolean
  isYoutube?: boolean
  isPhone?: boolean // Add this property
}

const headerNavLinks: NavLink[] = [
  { href: '/', title: 'Startseite' },
  {
    href: 'https://www.youtube.com/@GoDeutschland.energiel%C3%B6sungen',
    title: 'YouTube',
    openInNewTab: true,
    isYoutube: true,
  },
  {
    title: 'Volks-Lösungen',
    submenu: [
      { href: '/photovoltaik', title: 'Photovoltaik' },
      { href: '/heizung', title: 'Heizung' },
      { href: '/isolierung', title: 'Isolierung' },
    ],
  },
  {
    title: 'Wissensplattform',
    submenu: [
      { href: '/energyhouse', title: 'KI-Energiekonfigurator' },
      { href: 'https://www.godeutschland.info', title: 'Wiki', openInNewTab: true },
      {
        href: 'https://www.godeutschland.info/e-autorechner',
        title: 'E-Auto Rechner',
        openInNewTab: true,
      },
      {
        href: 'https://www.godeutschland.info/bensstory',
        title: "Ben's Story",
        openInNewTab: true,
      },
    ],
  },
  {
    title: 'Über uns',
    submenu: [
      { href: '/uberuns', title: 'Über uns' },
      { href: '/bewerbung', title: 'Bewerbung' },
      { href: '/empfehlungsprogramm', title: 'Empfehlungsprogramm' },
      { href: '/partnerprogram', title: 'Partnerprogramm' },
    ],
  },
  {
    href: 'tel:+49302239953879',
    title: '030 223 995 3879',
    isPhone: true,
  },
  {
    href: 'https://goenergy.quiply.io/#/switch?tenantKey=goenergy',
    title: 'Kundenportal',
    openInNewTab: true,
  },
  { href: '/termin', title: 'Ersparnis berechnen', isButton: true },
]

export default headerNavLinks
